module.exports = __webpack_public_path__ + "img/face23.15220c3c.jpg";